import React, { useEffect, useState } from "react";
import { FaAngleUp } from "react-icons/fa6";

const ScrollTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const scrollElement = document.getElementById("page-wrapper");

        const getScrollTop = () => {
            if (scrollElement) return scrollElement.scrollTop;
            return window.scrollY || document.documentElement.scrollTop;
        };

        const getScrollLimit = () => {
            if (scrollElement) return scrollElement.clientHeight;
            return window.innerHeight;
        };

        const handleScroll = () => {
            const scrollTop = getScrollTop();
            const limit = getScrollLimit();

            setVisible(scrollTop > limit);
        };

        handleScroll();

        const target = scrollElement ?? window;
        target.addEventListener("scroll", handleScroll);

        return () => target.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        const scrollElement = document.getElementById("page-wrapper");

        if (scrollElement) {
            scrollElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            return;
        }

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    if (!visible) return null;

    return (
        <button
            onClick={scrollToTop}
            style={{
                position: "fixed",
                right: "9px",
                bottom: "12px",
                zIndex: 999,
                opacity: 0.7,
                transition: "opacity 0.2s ease"
            }}
            className="bg-white border border-gray-300 rounded-md w-8 h-8 flex items-center justify-center shadow hover:bg-gray-100 cursor-pointer"
        >
            <FaAngleUp/>
        </button>
    );
};

export default ScrollTopButton;
